import { erpAxios } from '..';

const notifikacijeCount = async (officerId) => {
  const { data } = await erpAxios(`/sistemskeNotifikacije/count/${officerId}`);
  return data;
};

export default notifikacijeCount;